(function () {
  'use strict';
  const order = ['Chenille', 'Bouclé', 'Loft Bouclé', 'Velour Suede', 'Cloudsoft Weave', 'Linen', 'Microfibre', 'Eco leather', 'Performance Diamond', 'Rubbed leather', 'Premium Natural'];
  const normalise = value => {
    if (/^Premium Natural/i.test(value)) return 'Premium Natural';
    if (/^Premium Rubbed|^Rubbed leather/i.test(value)) return 'Rubbed leather';
    if (/^Performance/i.test(value)) return 'Performance Diamond';
    if (/^Eco (Genuine )?Leather$/i.test(value)) return 'Eco leather';
    return value.replace(/ Fabric$/i, '');
  };
  const words = el => JSON.parse(el.querySelector('.sofa-material-pricing-copy').textContent);
  const label = (el, value) => value === 'Performance Diamond' ? words(el).diamond : value;
  const groups = rows => [...new Set(rows.map(row => row.material))].sort((a, b) => {
    const rank = value => order.includes(value) ? order.indexOf(value) : order.length;
    return rank(a) - rank(b);
  });
  const base = (rows, size) => Math.min(...rows.filter(row => (!size || row.size === size) && !['Rubbed leather', 'Premium Natural'].includes(row.material)).map(row => row.price));
  const surcharge = (rows, row) => Math.max(0, row.price - base(rows, row.size));
  const classicRow = row => {
    const parts = (row.title === 'Default Title' ? row.name : row.title).split('|').map(part => part.trim());
    const embeddedNatural = /^Premium Natural Fabric\s+\S/.test(parts[0]);
    return {...row, material: normalise(parts[0]), colour: embeddedNatural ? parts[0].replace(/^Premium Natural Fabric\s*/, '') : parts[1] || parts[0], code: embeddedNatural ? parts[1] || '' : parts[2] || '', image: row.image || row.swatch};
  };
  const decorate = (el, button, material, count) => {
    button.replaceChildren();
    const name = document.createElement('span'); name.className = 'lf-material-name'; name.textContent = label(el, material);
    const number = document.createElement('small'); number.className = 'lf-material-count'; number.textContent = count;
    const price = document.createElement('span'); price.className = 'lf-material-price';
    button.append(name, number, price);
  };
  const update = (el, row, rows) => {
    const copy = words(el);
    el.querySelectorAll('.lf-material').forEach(button => {
      const choices = rows.filter(choice => choice.material === button.dataset.material && (!row.size || choice.size === row.size));
      const amount = choices.length ? Math.max(0, Math.min(...choices.map(choice => choice.price)) - base(rows, row.size)) : 0;
      const badge = button.querySelector('.lf-material-price');
      if (badge) { badge.textContent = amount > 0 ? '+' + el.money(amount) : copy.included; badge.classList.toggle('is-upgrade', amount > 0); }
    });
    const help = el.querySelector('.lf-material-help');
    const amount = surcharge(rows, row);
    const detail = ['Loft Bouclé', 'Velour Suede', 'Cloudsoft Weave'].includes(row.material) ? row.description : row.material === 'Premium Natural' ? copy.natural_help : row.material === 'Rubbed leather' ? copy.leather_help : row.material === 'Eco leather' ? copy.eco_help : copy.included_help;
    if (help) help.textContent = detail + (amount > 0 ? ' +' + el.money(amount) + '.' : '');
  };
  window.CoucheryMaterials = Object.freeze({normalise, label, groups, base, surcharge, classicRow, decorate, update});
})();





